import type { CollectionSort } from "./collection-grid-options";

export function normalizeCollectionSort(
  sort: CollectionSort | "editorial" | undefined,
): CollectionSort {
  if (!sort || sort === "editorial") return "rankingAsc";

  return sort;
}
